module.exports = __webpack_public_path__ + "0100d5aa6a64207738af7189fb72270a.svg";